import { CommonModule } from '@angular/common';
import { Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { SettingPriceListComponent } from './setting-price-list/setting-price-list.component';
import { SettingPromotionListComponent } from './setting-promotion-list/setting-promotion-list.component';
import { IAPIListResult, IPaginationResult, IPaginationResultFrequencies, IRequestResult } from 'app/common/interfaces';
import { MaterialPriceListService } from './strategy-price-list.service';
import MaterialPriceListAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-price-list/material-price-list.entity';
import { ConditionClassEnum } from './condition-class-enum';
import { ExportService } from 'app/layout/export-overlay/export-overlay.service';
import { ExportDialogComponent } from 'app/layout/export-overlay/dialog/export-dialog.component';
import { ExportOptions } from 'app/layout/export-overlay/tasks/core/export-task.interfaces';
import { environment } from 'environments/environment.prod';
import { MaterialService } from '../../material/material/material.service';
import { MaterialAttributes } from '@albatrosdeveloper/ave-models-package';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatDatepickerModule } from '@angular/material/datepicker';
import SalesOrganizationAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-organization/sales-organization.entity';
import { SalesOrganizationService } from '../../configuration/sales-organization/sales-organization.component.service';
import { getCode } from 'app/utils/method';
import { SequenceReadingService } from './sequence-reading.service';
import { StrategyListExport } from './exports/strategy-list.export';
import { STRATEGY_LIST_TITLE } from './exports/strategy-list.constants';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { NoFiltersAvailableComponent } from 'app/common/components/no-filters-available/no-filters-available.component';



@Component({
  selector: 'app-strategy-list',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatButtonModule,
    HoverMenuDirective,
    MatMenuModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatBadgeModule,
    NgxMatSelectSearchModule,
    MatDatepickerModule,
    FilterComponent,
    NoFiltersAvailableComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    StrategyListExport
  ],
  templateUrl: './strategy-list.component.html',
  styleUrl: './strategy-list.component.scss'
})
export class StrategyListComponent implements OnDestroy {
  getCode = getCode
  displayedColumns: string[] = [
    "name", 
    "price_list",
    "discount_list",
    "promotions_list", 
    "actions"
  ];

  dataSource = new MatTableDataSource<any>([]);
  
  totalItems = 0
  search: string = '';
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof any = "name";
  sortDirection: "ASC" | "DESC" = "ASC";

  conditionClass: {code: ConditionClassEnum, name: string}[] = [
    {code: ConditionClassEnum.XP01, name: 'Precio'},
    {code: ConditionClassEnum.XG01, name: 'Promoción'}
  ]

  sequenceList: any[] = []
  sequenceListFilter: any[] = []
  sequenceNames: Record<string, string> = {
    'S1': 'Precios Especiales',
    'S2': 'Precios'
  };

  salesOrganizationList: SalesOrganizationAttributes[] = [];
  
  materialList: MaterialAttributes[] = [];
  searchMaterial = ''
  private searchSubject = new Subject<string>();

  currentCreatePriceList: MaterialPriceListAttributes = this.initializeCreatePriceList();
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;

  dialogRefAdd: MatDialogRef<any>;
  
  fileToUpload: File;
  aux_file = false
  
  range: FormGroup;

  //BUSCADOR
  searchSubscription: Subscription;
  
  constructor(
    private materialPriceListService: MaterialPriceListService,
    private readonly sequenceReadingService: SequenceReadingService,
    private readonly salesOrganizationService: SalesOrganizationService,
    private readonly materialService: MaterialService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    public exportService: ExportService,
    private fb: FormBuilder,
    private strategyListExport: StrategyListExport
  ) { 
    this.range = this.fb.group({
      start: [null],
      end: [null]
    });
  }

  ngOnInit() {
    this.onHandleSearch();
    this.range.patchValue({
      start: this.currentCreatePriceList.dateStart ? new Date(this.currentCreatePriceList.dateStart) : null,
      end: this.currentCreatePriceList.dateEnd ? new Date(this.currentCreatePriceList.dateEnd) : null,
    });
  }
  

  ngAfterViewInit(): void {
    this.getList();
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.getList()
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.pageIndex = 1
        this.search = term
        this.getList()
      });
  }

  getList(): void {
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }

    this.materialPriceListService.findAllGlobalWithCount(options).subscribe({
      next: (res: IPaginationResult<any>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        //this.dataSource.data = res?.data?.data ?? []

        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;

        this.dataSource.data.forEach((item: any) =>{
          if(Array.isArray(item.conditionCounts)){

            item.price_list = item.conditionCounts.find(
              ({ conditionClass, sequenceType }) =>
                conditionClass === ConditionClassEnum.XP01 && sequenceType === 'S2'
            ) || null;
        
            item.liquidation_list = item.conditionCounts.find(
              ({ conditionClass, sequenceType }) =>
                conditionClass === ConditionClassEnum.XP01 && sequenceType === 'S1'
            ) || null;
        
            item.promotions_list = item.conditionCounts.find(
              ({ conditionClass }) => conditionClass === ConditionClassEnum.XG01) || null;
          }
        })
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener precios de materiales.","Cerrar",{ duration: 5000});
      },
    })
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction.toUpperCase() || 'ASC'
    this.getList()
  }

  changePage(e: PageEvent) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getList()
  }

  private initializeCreatePriceList(): MaterialPriceListAttributes {
    return { 
      conditionClass: null, 
      sequence: null,
      field1: null, // org venta
      field2: null, //
      field3: null, //
      field4: null, // precio lista
      field5: null, // currency
      field6: null, // id material
      field7: null, // unidad de medida
      field8: null, // range
      field9: null,
      field10: null,
      field11: null,
      field12: null,
      field13: null,
      dateStart: null,
      dateEnd: null,
      price: 0, // price
      minimumPrice: 0,
      maximumPrice: 0,
      hasScalePrices: false,
      hasMinimumAndMaximunPrices: false,
      scalePrices: []
    };
  }

  openCreateModal(): void {
    this.getAllSalesOrganization()
    this.getMaterialList()
    this.setupMaterialSearchControl()
    this.getSequence()

    this.currentCreatePriceList = this.initializeCreatePriceList();
    this.dialogRefAdd= this.dialog.open(this.addModal, { width: '90%' , disableClose: true })
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  createMaterialPriceList() {  
    const createPriceList: MaterialPriceListAttributes = {
      conditionClass: this.currentCreatePriceList.conditionClass,
      sequence: this.currentCreatePriceList.sequence,
      field1: this.currentCreatePriceList.field1, // org venta
      field2: this.currentCreatePriceList.field2, //
      field3: this.currentCreatePriceList.field3, //
      field4: this.currentCreatePriceList.field4, // precio lista
      field5: this.currentCreatePriceList.field5, // currency
      field6: this.currentCreatePriceList.field6, // id material
      field7: this.currentCreatePriceList.field7, // unidad de medida
      field8: this.currentCreatePriceList.field8, // range
      field9: this.currentCreatePriceList.field9,
      field10: this.currentCreatePriceList.field10,
      field11: this.currentCreatePriceList.field11,
      field12: this.currentCreatePriceList.field12,
      field13: this.currentCreatePriceList.field13,
      // dateStart: new Date(this.currentCreatePriceList.dateStart).toISOString().split('T')[0],
      // dateEnd: new Date(this.currentCreatePriceList.dateEnd).toISOString().split('T')[0],
      dateStart: this.range.value.start ? new Date(this.range.value.start).toISOString().split('T')[0] : null,
      dateEnd: this.range.value.end ? new Date(this.range.value.end).toISOString().split('T')[0] : null,
      price: this.currentCreatePriceList.price, // price
      minimumPrice: this.currentCreatePriceList.minimumPrice,
      maximumPrice: this.currentCreatePriceList.maximumPrice,
      hasScalePrices: this.currentCreatePriceList.hasScalePrices,
      hasMinimumAndMaximunPrices: this.currentCreatePriceList.hasMinimumAndMaximunPrices,
      scalePrices: this.currentCreatePriceList.scalePrices
    };
  
    if(createPriceList.field6 == null){
      return;
    }
    this.materialPriceListService.create(createPriceList).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        if(this.dialogRefAdd){
          this.dialogRefAdd.close(true);
        }
        this.getList()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  openDeleteDialog(list: any): void {
    this.dialog
      .open(this.deleteDialog, { data: list, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(list.materialId));
  }

  delete(id: string): void {
    this.materialPriceListService.remove(id).subscribe(() => {
      this.getList();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  openModalSettingPriceList(strategyList: any): void {
    const dialogRef = this.dialog.open(SettingPriceListComponent, {
      data: strategyList,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getList()
    });
  }

  openModalSettingPromotionList(strategyList: any): void{
    const dialogRef = this.dialog.open(SettingPromotionListComponent, {
      data: strategyList,
      disableClose: true
    })
    dialogRef.afterClosed().subscribe((result) => {
      this.getList()
    })
  }

  downloadPriceListTemplate() {
    const url = this.materialPriceListService.getFileTemplatePriceList();
    if (!url) {
      this.snackBar.open("Plantilla no disponible.", "Cerrar", {
        duration: 3000,
      });
      return;
    }
    window.open(url);
  }

  async handleFileInput(event) {
    this.aux_file = true
    this.fileToUpload = event.target.files[0];
    if(this.fileToUpload){
      if(this.fileToUpload.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
        this.snackBar.open("Ingrese solo de tipo .xlsx", "Cerrar", {duration: 3000})
      }
    }else{
      this.aux_file = false
    } 
  }

  onMessageConfirm(){
    if(this.fileToUpload){

      let send = {
        file: this.fileToUpload
      }

      //formdata
      let formdata = new FormData()
      for(let key in send){  
        formdata.append(key,send[key])
      }

      this.materialPriceListService.importFile(formdata).subscribe({
        next: (res: any) => {
          this.snackBar.open(res.message, "Cerrar", {duration: 3000})
          this.aux_file = false
          this.getList()
        },
        error: (err) => {
          this.aux_file = false
          this.snackBar.open(err.error.message || 'Error al subir el registro', 'Cerrar', { duration: 3000 });
        },
      })
    }
  }


  onExportButtonPressed() {
    if (!this.strategyListExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: STRATEGY_LIST_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.strategyListExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
        );
      }
    });
  }

  //
  private getSequence(): void {
    const options = {
      search: null,
      currentPage: 1,
      limitPerPage: 50,
      //sortActive: "name",
      //sortDirection: "ASC"
    };

    this.sequenceReadingService.findAllWithCount(
      options,
      this.currentCreatePriceList.conditionClass
    ).subscribe({
      next: (res: IAPIListResult<any>) => {

        if(Array.isArray(res.data)){
          const sequenceList = res.data?.[0]?.sequences;
          this.sequenceList = sequenceList.map(field => ({
            code: field.sequence,
            name: this.sequenceNames[field.sequence] || field.sequence
          }));

          //this.sequenceListFilter = this.sequenceList.slice()
          if (this.currentCreatePriceList.conditionClass === ConditionClassEnum.XG01) {
            this.sequenceListFilter = this.sequenceList
              .filter(e => e.code === 'S1') // Filtra solo los 'S1'
              .map(e => ({
                ...e,
                name: 'Promociones' // Actualiza el nombre si es 'S1'
              }));
          } else {
            this.sequenceListFilter = this.sequenceList.slice();
          }
        }
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener secuencias.","Cerrar",{ duration: 5000});
      },
    });
  }

  changeCondition(){
    /* if(this.currentCreatePriceList.conditionClass == ConditionClassEnum.XG01){
      this.sequenceListFilter = this.sequenceList.filter(e => e.code == 'S1')
      .map(e => {
        if (e.code === 'S1') {
          e.name = 'Promociones';
        }
        return e;
      });
    } */

    this.sequenceListFilter = []
    this.getSequence()
  }

  private getAllSalesOrganization(): void {
    this.salesOrganizationService.findToComboBox().subscribe({
      next: (res) => {
        this.salesOrganizationList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener organizaciones de ventas.","Cerrar",{ duration: 5000});
      },
    });
  }

  private getMaterialList(): void{
    const materialOptions = {
      search: this.searchMaterial ? this.searchMaterial: null,
      currentPage: 1,
      limitPerPage: 50,
      sortActive: "name",
      //sortDirection: "ASC"
    };

    const companyCodes = [environment.companyId];

    this.materialService.findAllComboNoCnfList(
      materialOptions,
      companyCodes,
      null,
    ).subscribe({
      next: (res: IPaginationResult<MaterialAttributes>) => {
        this.materialList = res?.data?.[0]?.data ?? [];
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener materiales.","Cerrar",{ duration: 5000});
      },
    })
  }

  changueOptionsMaterial(event){
    this.searchSubject.next(event);
  }

  private setupMaterialSearchControl(): void {
    this.searchSubject
    .pipe(
      debounceTime(500),
      distinctUntilChanged()
    )
    .subscribe((searchTerm) => {
      if(searchTerm){
        this.searchMaterial = searchTerm;
        this.getMaterialList();
      }
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
